import { ParagraphElement } from '@typedream/components';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_PARAGRAPH } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';

export const createParagraphPlugin = createTElementPluginFactory({
  key: ELEMENT_PARAGRAPH,
  component: withDropTarget(ParagraphElement),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/text.png',
      title: 'Text',
      subtitle: 'Start writing plain text',
      keywords: ['text', 'paragraph'],
    },
    format: {
      formatType: 'block',
      placeholderText: "Type '/' to show options",
      focusableWhenEmpty: true,
      validProperties: [
        'width',
        'width_max',
        'align',
        'mobile_hide',
        'desktop_hide',
        'animation',
        'connect_data',
        'padding',
        'margin',
      ],
    },
  },
});
